"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _userService = require("@insided/shared/services/userService");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _common = require("@insided/shared/utils/common");

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopLikedBy = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopLikedBy, _Component);

  var _super = _createSuper(TopLikedBy);

  function TopLikedBy() {
    var _this;

    (0, _classCallCheck2.default)(this, TopLikedBy);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      likedUsers: [],
      anonymousLikesCount: 0,
      likedByUsers: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchLikedUsers", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var likedBy, _likedBy$length, response, total, userData;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              likedBy = _this.props.likedBy;

              if (!((likedBy === null || likedBy === void 0 ? void 0 : likedBy.length) === 0)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return (0, _userService.fetchUserInfo)(likedBy);

            case 6:
              response = _context.sent;
              total = (_likedBy$length = likedBy === null || likedBy === void 0 ? void 0 : likedBy.length) !== null && _likedBy$length !== void 0 ? _likedBy$length : 0;
              userData = Object.values(response);

              _this.setState({
                likedUsers: userData,
                anonymousLikesCount: userData.length < total ? total - userData.length : 0,
                likedByUsers: likedBy
              });

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              // eslint-disable-next-line no-console
              console.log('Failed to fetch liked users:', _context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseEnterOrFocus", function () {
      var likedBy = _this.props.likedBy;
      var likedByUsers = _this.state.likedByUsers; // Fetch if not fetched yet OR if likedBy has changed

      if (likedByUsers.length === 0 || likedByUsers !== likedBy) {
        _this.fetchLikedUsers();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(TopLikedBy, [{
    key: "render",
    value: function render() {
      var _likedBy$length2;

      var _this$props = this.props,
          _this$props$topLikedB = _this$props.topLikedBy,
          topLikedBy = _this$props$topLikedB === void 0 ? [] : _this$props$topLikedB,
          likedBy = _this$props.likedBy,
          isCurrentUserLiked = _this$props.isCurrentUserLiked;
      var _this$state = this.state,
          likedUsers = _this$state.likedUsers,
          anonymousLikesCount = _this$state.anonymousLikesCount;
      var totalLikes = (_likedBy$length2 = likedBy === null || likedBy === void 0 ? void 0 : likedBy.length) !== null && _likedBy$length2 !== void 0 ? _likedBy$length2 : 0;
      var allUsers = likedUsers.length > 0 ? likedUsers : [];
      var phrase = '';

      if (!_common.common.isModuleActive('threadedRepliesDestination')) {
        if (isCurrentUserLiked && likedBy.length === 1) {
          phrase = 'post.like.number.only_self';
        } else if (isCurrentUserLiked && likedBy.length > 1) {
          phrase = 'post.like.number.including_self';
        } else {
          phrase = 'post.like.number';
        }
      }

      if (totalLikes === 0) {
        return null;
      }

      var ariaLabel = "".concat(totalLikes, " ").concat(totalLikes === 1 ? 'like' : 'likes');
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('post-like-list topic-liked-users', {
          'm-v': !_common.common.isModuleActive('threadedRepliesDestination')
        })
      }, (0, _preact.h)(_Tooltip.default, {
        withArrow: true,
        trigger: (0, _preact.h)("button", {
          type: "button",
          className: "topic-liked-users__trigger",
          "aria-label": ariaLabel,
          onMouseEnter: this.handleMouseEnterOrFocus,
          onFocus: this.handleMouseEnterOrFocus
        }, topLikedBy.map(function (user) {
          return (0, _preact.h)(_UserAvatar.default, {
            key: user.id,
            user: user,
            extraClass: "avatar avatar--XS",
            disablePopup: true,
            showRank: false,
            avatarBaseSize: "24x24",
            width: 16,
            height: 16
          });
        }), (0, _preact.h)("span", {
          className: "topic-liked-users_text",
          "aria-hidden": "true",
          "data-like-count": totalLikes
        }, _common.common.isModuleActive('threadedRepliesDestination') ? totalLikes === null || totalLikes === void 0 ? void 0 : totalLikes.toString() : (0, _preact.h)(_phrase.default, {
          p: phrase,
          count: {
            numberOfLikes: isCurrentUserLiked ? (totalLikes - 1).toString() : totalLikes.toString()
          }
        }))),
        tooltipMessage: (0, _preact.h)("ul", {
          className: "post-like-list__complete-list"
        }, allUsers.map(function (likedUser) {
          return (0, _preact.h)("li", {
            className: "post-like-list__item",
            key: likedUser.id
          }, (0, _preact.h)("a", {
            className: "link",
            href: (0, _absoluteUrlRuntime.resolveUrl)(likedUser.url)
          }, (0, _preact.h)(_UserAvatar.default, {
            user: likedUser,
            extraClass: "avatar avatar--S",
            disablePopup: true,
            showRank: false,
            avatarBaseSize: "24x24",
            width: 16,
            height: 16
          }), (0, _preact.h)("span", null, likedUser.name)));
        }), anonymousLikesCount > 0 && (0, _preact.h)("li", {
          className: "post-like-list__item"
        }, (0, _preact.h)("div", {
          className: "wrapper"
        }, (0, _preact.h)(_UserAvatar.default, {
          user: {
            id: '',
            name: 'Anonymous',
            avatar: ''
          },
          extraClass: "avatar avatar--S",
          disablePopup: true,
          showRank: false
        }), (0, _preact.h)(_phrase.default, {
          p: "anonymous.users.count",
          count: {
            n: anonymousLikesCount
          },
          renderAsText: true
        }, function (anonymousLikes) {
          return (0, _preact.h)("span", {
            "data-like-count": anonymousLikesCount
          }, anonymousLikes);
        }))))
      }));
    }
  }]);
  return TopLikedBy;
}(_preact.Component);

var _default = TopLikedBy;
exports.default = _default;